import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText } from '@mui/material';

const OficiulTehnic: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Oficiul Tehnic
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Responsabil: Pr. Gheorghe Pante (Zagaroli)
          </Typography>
          <Typography variant="body1">
            Oficiul Tehnic se ocupă de aspectele tehnice și 
            de întreținerea infrastructurii eparhiei.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OficiulTehnic;
